import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  exchanges: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  authedBrands: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  competitors: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  orgAdditionalTypes: { data: [], loading: false },
  price: { data: null, loading: false },
  step: { step1: null, step2: [], step3: null, step5: null },
  detail: { data: null, loading: false },
  orgInfo: { data: null, loading: false },
  orderInfo: { data: null, loading: false },
  orgChecked: { data: false, loading: false },
  dialog: { visible: false, loading: false },
  confirm: { name: '', title: '', content: '', active: null, visible: false, loading: false },
  alert: { title: '', content: '', visible: false, loading: false },
  searchParams: null,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
